import { Trophy } from "lucide-react";
import { useStore } from "@/store/AppStore";
import { PageHeader, Panel, Initials } from "@/components/kit";
import { RankingTable } from "@/components/Lists";
import { MonthHighlights, YearHighlights } from "@/components/Highlights";
import { ranking } from "@/lib/selectors";
import { PROFILES, MONTH_LABEL } from "@/data/mock";
import { brl } from "@/lib/format";

const HEIGHTS = { 1: "h-36", 2: "h-28", 3: "h-20" };

function Podium({ rows }) {
  const order = [rows[1], rows[0], rows[2]].filter(Boolean);
  return (
    <div className="flex items-end justify-center gap-3 sm:gap-6" data-testid="ranking-podium">
      {order.map((r) => (
        <div key={r.id} className="flex w-28 flex-col items-center sm:w-36">
          {r.position === 1 && <Trophy className="mb-2 h-6 w-6 text-gold" />}
          <Initials name={r.name} className="h-14 w-14 text-base ring-2 ring-gold" />
          <p className="mt-3 text-center text-sm font-semibold">{r.name.split(" ")[0]}</p>
          <p className="text-xs text-neutral-500">{brl(r.sales)}</p>
          <div className={`mt-3 flex w-full items-start justify-center rounded-t-lg pt-3 font-display text-2xl font-semibold ${HEIGHTS[r.position]} ${r.position === 1 ? "bg-gold text-neutral-900" : "bg-neutral-900 text-gold"}`}>{r.position}º</div>
        </div>
      ))}
    </div>
  );
}

export default function OwnerRanking({ highlightId }) {
  const { state } = useStore();
  const rows = ranking(state, PROFILES.empresaria.companyId);
  return (
    <div data-testid="owner-ranking-page">
      <PageHeader eyebrow={MONTH_LABEL} title="Ranking mensal" subtitle="Pontuação = 70% atingimento da meta de vendas + 30% tarefas concluídas." />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
        <Panel title="Pódio" className="lg:col-span-2"><Podium rows={rows} /></Panel>
        <Panel title="Classificação completa" className="lg:col-span-3"><RankingTable rows={rows} highlightId={highlightId} /></Panel>
        <MonthHighlights companyId={PROFILES.empresaria.companyId} className="lg:col-span-5" />
        <div className="lg:col-span-5"><YearHighlights companyId={PROFILES.empresaria.companyId} /></div>
      </div>
    </div>
  );
}
